import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  IApprovalItemComment,
  IApprovalItemCommentAicByEnum,
} from "../../services/thumbz-base-api";
import { Card, CardContent, Chip } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import { formatInTimeZone } from "date-fns-tz";
import { getInitials } from "../../utils/get-initials";

export interface ChatBubbleProps {
  comment: IApprovalItemComment;
  showSenderInfo?: boolean;
}

export function ChatBubble({
  comment,
  showSenderInfo = true,
}: ChatBubbleProps): React.JSX.Element {
  const name =
    comment.aic_by === IApprovalItemCommentAicByEnum.Customer
      ? comment.customer?.cust_name
      : comment.user?.usu_name;
  const avatar =
    comment.aic_by === IApprovalItemCommentAicByEnum.Customer
      ? comment.customer?.cust_photo?.ast_url
      : comment.user?.usu_photo.ast_url;
  const adjustedDate = formatInTimeZone(
    comment.aic_created_at,
    "America/Sao_Paulo",
    "yyyy-MM-dd HH:mm:ss",
  );

  const timeAgo = formatDistanceToNow(adjustedDate, {
    addSuffix: true,
    locale: ptBR,
  });

  const commentText = comment.aic_comment;

  const direction =
    comment.aic_by === IApprovalItemCommentAicByEnum.User
      ? "row"
      : "row-reverse";

  if (comment.aic_by === IApprovalItemCommentAicByEnum.System) {
    return (
      <Stack
        direction={"column"}
        alignItems={"center"}
        alignSelf={"center"}
        alignContent={"center"}
        justifyContent={"center"}
      >
        <Chip
          size="small"
          label={commentText ?? ""}
          color={comment.aic_color ?? undefined}
        />
        {/* <Typography pl={2} mt={0.25} variant="caption" color="text.secondary">
          {timeAgo}
        </Typography> */}
      </Stack>
    );
  }

  return (
    <Stack direction={direction} spacing={2} alignItems="flex-start">
      {showSenderInfo ? (
        <Avatar
          src={avatar ?? undefined}
          aria-label={name || "Anonymous"}
          alt={name || "Anonymous"}
        >
          {!avatar && getInitials(name || "Anonymous")}
        </Avatar>
      ) : (
        <Box sx={{ width: 40, height: 40 }} />
      )}
      <Stack>
        {showSenderInfo && (
          <Typography variant="caption" color="text.secondary">
            {name || "Anonymous"}
          </Typography>
        )}
        <Card
          elevation={4}
          variant="outlined"
          sx={{ borderWidth: 2, borderRadius: 1 }}
        >
          <CardContent sx={{ p: 1.25 }}>
            <Typography variant="body2" color="text.primary">
              {commentText}
            </Typography>
          </CardContent>
        </Card>
        <Typography pl={2} mt={0.25} variant="caption" color="text.secondary">
          {timeAgo}
        </Typography>
      </Stack>
    </Stack>
  );
}
